<div class="detail-bool-container">
  <mat-slide-toggle color="accent" [ngModel]="value" disabled></mat-slide-toggle><span class="detail-bool-label">{{header}}</span>
</div>
